module.exports = __webpack_public_path__ + "static/img/202.85ce956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/202.jpg
// module id = wRPz
// module chunks = 0